(function ($) {
  'use strict';

  // Guard against double-loading when multiple sections include this file
  if (window.corstonScrollRevealInit) return;
  window.corstonScrollRevealInit = true;

  // Gate the hidden initial state on JS being available,
  // so content stays visible for no-JS visitors
  document.documentElement.className += ' js';

  $(function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var $reveals = $('.r');

    if (!$reveals.length) return;

    $reveals.each(function () {
      var d = $(this).attr('data-d');
      if (d) this.style.transitionDelay = d + 'ms';
    });

    function reveal(el) {
      $(el).addClass('in');
      // Clear the stagger delay once the reveal has played, so later
      // transitions on the same element (e.g. the newsletter subtext fading
      // out on submit) start immediately instead of waiting for the delay
      var d = parseInt($(el).attr('data-d'), 10) || 0;
      setTimeout(function () {
        el.style.transitionDelay = '';
      }, 750 + d);
    }

    if (reduce || !('IntersectionObserver' in window)) {
      $reveals.each(function () {
        reveal(this);
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    var onLoad = [];
    $reveals.each(function () {
      // Anything already in view on load (the hero) reveals straight away
      var rect = this.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        onLoad.push(this);
      } else {
        io.observe(this);
      }
    });

    // Wait two frames so the opacity:0 state is painted first — otherwise the
    // browser collapses both states into one recalc and the fade is skipped
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        onLoad.forEach(reveal);
      });
    });
  });
})(jQuery);
